import { Injectable } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';

import { GuidId, List, ListPrimaryKeyId, ProjectPrimaryKeyId } from '../models';
import { ApiService } from './api/index';

/**
 * Site management service
 */
@Injectable({
  providedIn: 'root',
})
export class ProjectListService {
  constructor(private api: ApiService) {}

  /**
   * Get page data from local and/or server
   * @param {number} listId is either local site.id or cloudId
   * @param {number} projectId used for local query only (?)
   * @returns
   *
   * @since 1.3.0
   */
  getList(
    listId: ListPrimaryKeyId,
    projectId: ProjectPrimaryKeyId,
    projectGuid: GuidId,
  ): Observable<{
    site: List.List;
    defects: List.DefectView[];
  }> {
    let site: List.List,
      defects: List.DefectView[] = [];

    return this.api.client.getList(listId, projectId, projectGuid).pipe(
      map((result) => {
        if (result.success) {
          site = {
            ...result.data.site,
            cloudId: result.data.site.id,
            projectCloudId: projectId,
            unit: result.data.site.description,
            address: result.data.site.address,
            floor: result.data.site.floor,
            notes: result.data.site.notes,
            type: result.data.site.type,
            lastModified: result.data.site.lastModified ?? 0,
          };
          defects = result.data.defects.map<List.DefectView>((cd: any) => {
            return {
              ...cd,
              id: null,
              photo: cd.fullSizePath,
              thumbnail: cd.photo,
              cloudId: cd.id,
              imageErrorCount: 0,
              isSynced: 0,
              hasComments: cd.hasComments > 0,
            };
          });
        }

        return { site: site!, defects };
      }),
      catchError((err) => {
        console.error(err);
        return throwError(() => new Error(`Unable to load list. ${err}`));
      }),
    );
  }
}
